<template>
  <div>
    <small class="label">{{ $l.userName }}</small>
    <input
      type="text"
      class="input-text with-label"
      v-model="name"
      :placeholder="$l.userName"
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    name: {
      get: function () {
        return this.$store.state.user.name
      },

      set: function (name) {
        this.$store.commit('user/setName', name)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
